var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1953 16.8788C22.2253 13.61 29.0604 11.6442 36.3255 11.3576L36.3255 21.0333C36.3255 21.2549 36.2376 21.4674 36.0813 21.624L24.8505 32.8712C23.0279 26.9469 20.0557 21.5287 16.1953 16.8788Z",
    fill: "#2C95D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.9095 22.0297C18.7876 20.2262 17.5458 18.5055 16.1953 16.8788C22.2253 13.61 29.0604 11.6442 36.3255 11.3576L36.3255 11.4827C30.1122 13.8081 24.5306 17.4337 19.9095 22.0297Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30465 23.6426L0.291294 21.624C0.135152 21.4674 0.0474281 21.255 0.0474281 21.0336L0.0474205 5.99481C4.69879 8.59822 8.8564 11.9829 12.3439 15.9718C8.65289 18.065 5.2768 20.6517 2.30465 23.6426Z",
    fill: "#0AB88A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.0779219 6.0119C4.71697 8.61303 8.86402 11.9916 12.3439 15.9718C10.8165 16.838 9.34302 17.7887 7.92979 18.8176C6.0102 14.1134 3.34359 9.79532 0.0779219 6.0119Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.421 14.8628C10.3692 10.5173 5.49499 6.95318 0.0472908 4.42021V0.887321C0.047287 0.426322 0.419819 0.0526123 0.879356 0.0526123L35.4933 0.0526155C35.9528 0.0526157 36.3254 0.426327 36.3254 0.887324L36.3254 10.0017C35.9176 9.99102 35.5084 9.98566 35.0981 9.98566C27.6669 9.98566 20.6446 11.7417 14.421 14.8628Z",
    fill: "#EF476F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.0474167 4.42022C5.49511 6.95319 10.3694 10.5173 14.4212 14.8628C20.6447 11.7417 27.667 9.98567 35.0982 9.98567C35.5086 9.98567 35.9177 9.99103 36.3255 10.0017L36.3255 9.70185C29.236 5.27851 20.8676 2.72369 11.9044 2.72369C7.80589 2.72369 3.83177 3.25786 0.0474167 4.26059V4.42022Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4427 35.2825C20.8604 28.9342 17.9759 23.1035 14.0905 18.0924C10.5634 20.2517 7.34667 22.8709 4.52318 25.8669L17.5881 38.9662C17.9128 39.2918 18.4392 39.292 18.7641 38.9665L22.4427 35.2825Z",
    fill: "#2A2A2A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4427 35.2825C20.8604 28.9342 17.9759 23.1035 14.0905 18.0924C10.5634 20.2517 7.34667 22.8709 4.52318 25.8669L17.5881 38.9662C17.9128 39.2918 18.4392 39.292 18.7641 38.9665L22.4427 35.2825Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcaLogo);
export default __webpack_public_path__ + "static/media/tca-logo.da1d887480a1dcdcf692604bf8ac980e.svg";
export { ForwardRef as ReactComponent };